import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = [{
  name: 'Laura P.',
  location: 'Buenos Aires',
  role: 'Psicóloga Clínica — Consultorio Privado',
  avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&h=80&fit=crop&crop=face',
  quote: 'Compré un domingo a la noche. El lunes entré a la sesión de las 9 con el encuadre armado, el plan clínico y los scripts listos. Nunca más llegué al consultorio sin saber qué iba a hacer.',
  time: '14:32',
  reply: 'Qué bueno que lo pudiste usar tan rápido 😊 Eso de llegar con estructura marca una diferencia enorme, se nota en la sesión.'
}, {
  name: 'Mariela C.',
  location: 'Rosario',
  role: 'Psicóloga — Centro de Salud Mental',
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face',
  quote: 'El protocolo de admisión del Tomo 1 me cambió todo. La primera semana detecté 2 pacientes que necesitaban derivación y pude hablarlo con claridad real desde el primer encuentro.',
  time: '09:15',
  reply: 'Eso es exactamente para lo que está pensado 🙌 Tener criterio clínico desde la admisión cambia el curso de todo el proceso.'
}, {
  name: 'Sofía V.',
  location: 'Córdoba',
  role: 'Psicóloga Independiente',
  avatar: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=80&h=80&fit=crop&crop=face',
  quote: 'Los checklists son únicos en el mercado. Antes tardaba 1 hora en armar un informe. Ahora abro el PDF, completo 3 casilleros y en 5 minutos tengo el reporte listo para el paciente.',
  time: '18:47',
  reply: 'Me alegra mucho que te haya servido así 😄 Esa hora que recuperás por informe la podés poner en más pacientes, o simplemente en vos.'
}, {
  name: 'Florencia L.',
  location: 'Tucumán',
  role: 'Psicóloga — Clínica Privada',
  avatar: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=80&h=80&fit=crop&crop=face',
  quote: 'Los scripts de honorarios del Tomo 6 eliminaron las conversaciones incómodas. Ahora los pacientes entienden el encuadre desde el día 1, lo aceptan y lo respetan.',
  time: '11:03',
  reply: 'Cuando el encuadre está claro desde el principio todo fluye diferente 😌 Me alegra que lo estés viviendo así.'
}, {
  name: 'Ana R.',
  location: 'Mendoza',
  role: 'Psicóloga Clínica y Docente',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face',
  quote: 'Mi tasa de adherencia pasó del 40% al 80%. Sin cambiar lo que hago clínicamente. Solo aplicando los scripts de seguimiento y el sistema de cancelaciones. En 3 meses llené todos mis horarios.',
  time: '20:21',
  reply: 'Es increíble lo que pasa cuando el seguimiento tiene estructura 😊 Y lo mejor es que no cambiaste tu trabajo clínico, solo le pusiste sistema alrededor.'
}, {
  name: 'Valeria T.',
  location: 'Santa Fe',
  role: 'Psicóloga — Gabinete Interdisciplinario',
  avatar: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=80&h=80&fit=crop&crop=face',
  quote: 'Ahora entrego el consentimiento informado en la primera entrevista y uso el sistema de abono desde el mes 1. Todos mis pacientes lo aceptaron. Este mes cobré el 100% antes del día 5. Primera vez en mi vida.',
  time: '16:58',
  reply: 'Qué lindo leer eso 🥹 Cuando el encuadre económico está claro desde el principio, los pacientes lo respetan. Te lo merecés.'
}, {
  name: 'Gabriela R.',
  location: 'Salta',
  role: 'Psicóloga Independiente',
  avatar: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?w=80&h=80&fit=crop&crop=face',
  quote: 'El protocolo de crisis del Tomo 4 me salvó la semana más complicada del año. Tuve 3 sesiones seguidas con pacientes en crisis y familias desbordadas. Con el protocolo de 3 pasos manejé todo sin perder el hilo.',
  time: '13:44',
  reply: 'Esas semanas existen y son agotadoras 😔 Tener un protocolo claro en esos momentos hace toda la diferencia. Bien que lo pudiste sostener.'
}];
function WhatsAppChat({
  t
}: {
  t: (typeof testimonials)[0];
}) {
  return <div className="rounded-xl overflow-hidden shadow-lg w-full shrink-0" style={{
    backgroundColor: '#111b21'
  }} data-id="element-303">
      <div className="flex items-center gap-3 px-4 py-3" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-304">
        <div className="relative" data-id="element-305">
          <img src={t.avatar} alt={t.name} width={40} height={40} loading="lazy" decoding="async" className="w-10 h-10 rounded-full object-cover" data-id="element-306" />
          <div className="absolute bottom-0 right-0 w-3 h-3 rounded-full border-2" style={{
          backgroundColor: '#7c3aed',
          borderColor: '#1f2c34'
        }} data-id="element-307" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-308">
          <p className="font-semibold text-white m-0 text-sm truncate" data-id="element-309">
            {t.name}
          </p>
          <p className="m-0 text-xs" style={{
          color: '#8696a0'
        }} data-id="element-310">
            {t.role} · {t.location}
          </p>
        </div>
        <div style={{
        color: '#aebac1'
      }} data-id="element-311">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-312">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" data-id="element-313" />
          </svg>
        </div>
      </div>

      <div className="px-3 py-4 min-h-[160px] flex flex-col justify-end gap-2" style={{
      backgroundColor: '#0b141a',
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='p' width='40' height='40' patternUnits='userSpaceOnUse'%3E%3Ccircle cx='20' cy='20' r='1' fill='%23ffffff08'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='200' height='200' fill='url(%23p)'/%3E%3C/svg%3E\")"
    }} data-id="element-314">
        <div className="max-w-[92%] self-start relative" data-id="element-315">
          <div className="absolute -left-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #1f2c34',
          borderLeft: '8px solid transparent'
        }} data-id="element-316" />
          <div className="rounded-lg rounded-tl-none px-3 py-2" style={{
          backgroundColor: '#1f2c34'
        }} data-id="element-317">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-318">
              {t.quote}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-319">
              <span className="text-xs" style={{
              color: '#8696a0'
            }} data-id="element-320">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-321">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#a78bfa" data-id="element-322" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#a78bfa" data-id="element-323" />
              </svg>
            </div>
          </div>
        </div>

        <div className="max-w-[75%] self-end relative mt-1" data-id="element-324">
          <div className="absolute -right-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #6d28d9',
          borderRight: '8px solid transparent'
        }} data-id="element-325" />
          <div className="rounded-lg rounded-tr-none px-3 py-2" style={{
          backgroundColor: '#6d28d9'
        }} data-id="element-326">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-327">
              {t.reply}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-328">
              <span className="text-xs" style={{
              color: '#c4b5fd'
            }} data-id="element-329">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-330">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#c4b5fd" data-id="element-331" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#c4b5fd" data-id="element-332" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2 px-3 py-2" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-333">
        <div style={{
        color: '#8696a0'
      }} data-id="element-334">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-335">
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-4-9a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm-5.5 3.5c.828 1.5 2.5 2.5 4.5 2.5s3.672-1 4.5-2.5" data-id="element-336" />
          </svg>
        </div>
        <div className="flex-1 rounded-full px-4 py-2 text-sm" style={{
        backgroundColor: '#2a3942',
        color: '#8696a0'
      }} data-id="element-337">
          Escribe un mensaje
        </div>
        <div style={{
        color: '#8696a0'
      }} data-id="element-338">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-339">
            <path d="M12 15c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5-3c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z" data-id="element-340" />
          </svg>
        </div>
      </div>
    </div>;
}
export function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const total = testimonials.length;
  useEffect(() => {
    const styleId = 'progress-keyframe';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        @keyframes progressFill {
          from { transform: scaleX(0); }
          to { transform: scaleX(1); }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);
  const goTo = useCallback((index: number, dir: number) => {
    setDirection(dir);
    setCurrent(index);
  }, []);
  const next = useCallback(() => {
    goTo((current + 1) % total, 1);
  }, [current, total, goTo]);
  const prev = useCallback(() => {
    goTo((current - 1 + total) % total, -1);
  }, [current, total, goTo]);
  useEffect(() => {
    intervalRef.current = setInterval(() => next(), 10000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [next]);
  const touchStartX = useRef(0);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();else prev();
    }
  };
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -300 : 300,
      opacity: 0
    })
  };
  return <section className="w-full px-4 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(245,243,255) 0%, rgb(245,243,255) 15%, rgb(245,243,255) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-341">
      <div className="mx-auto max-w-2xl" data-id="element-342">
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-343">
          Lo que dicen los psicólogos{' '}
          <span className="text-violet-700" data-id="element-344">que ya lo implementaron:</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-345">
          +500 psicólogos de todo el país ya tienen un sistema que funciona.
        </p>

        <div className="relative" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-346">
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 translate-x-0 sm:-translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          backgroundColor: '#7c3aed',
          color: '#fff'
        }} aria-label="Anterior testimonio" data-id="element-347">
            <ChevronLeftIcon size={20} data-id="element-348" />
          </button>

          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-0 sm:translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          backgroundColor: '#7c3aed',
          color: '#fff'
        }} aria-label="Siguiente testimonio" data-id="element-349">
            <ChevronRightIcon size={20} data-id="element-350" />
          </button>

          <div className="overflow-hidden rounded-xl mx-10 sm:mx-0" data-id="element-351">
            <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-352">
              <motion.div key={current} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-353">
                <WhatsAppChat t={testimonials[current]} data-id="element-354" />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="mt-4 mx-auto max-w-xs h-1 rounded-full overflow-hidden" style={{
          backgroundColor: 'rgb(226, 232, 240)'
        }} data-id="element-355">
            <div key={`progress-${current}`} className="h-full rounded-full" style={{
            backgroundColor: '#7c3aed',
            width: '100%',
            transformOrigin: 'left',
            animation: 'progressFill 10s linear forwards'
          }} data-id="element-356" />
          </div>

          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-357">
            {testimonials.map((_, i) => <button key={i} onClick={() => goTo(i, i > current ? 1 : -1)} className="transition-all duration-300 rounded-full" style={{
            width: i === current ? 24 : 8,
            height: 8,
            backgroundColor: i === current ? '#7c3aed' : 'rgb(203, 213, 225)'
          }} aria-label={`Ir al testimonio ${i + 1}`} data-id="element-358" />)}
          </div>

          <p className="text-center mt-3 m-0 text-xs text-gray-400" data-id="element-359">
            {current + 1} / {total}
          </p>
        </div>
      </div>
    </section>;
}